module.exports = "<igo-feature-list\r\n  igoFeatureListBinding\r\n  [focusFirst]=\"true\"\r\n  (focus)=\"handleFeatureFocus($event)\"\r\n  (select)=\"handleFeatureSelect($event)\">\r\n</igo-feature-list>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/tool/tools/search-results-tool/search-results-tool.component.html
// module id = 1154
// module chunks = 0